import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import Utils from "../../utils/Utils";
import PlayerCard from "../card/PlayerCard";

const ShotTypeModal = ({ open = false, setOpen = null, data = { data: [] }, leagueType = "", year = "" }) => {
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    if (data["data"].length > 0) {
      setCardData(
        data?.["data"].map((dt) => {
          return {
            teamName: dt["Logos"],
            playerName: dt["Players"],
            list: [
              `Frequency: ${Utils.toPercent(dt[`${data["key"]} Frequency`])}`,
              `SQ PPP: ${dt[`${data["key"]} SQ PPP`].toFixed(2)}`,
              `Occurrences: ${dt[`${data["key"]} Occurrences`]}`,
            ],
            year,
            leagueType,
          };
        })
      );
    }
  }, [data]);

  const handleModalClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      classNames={{ modal: "playType-modal", overlay: "customOverlay" }}
      onClose={handleModalClose}
      center
    >
      <div className="container">
        <div className="row">
          <div className="col-sm-12 mb-3">
            <h2>Top Players in {data?.["key"]}</h2>
          </div>
        </div>
        <div className="row">
          {cardData.length > 0 &&
            cardData.map((dt, index) => {
              return (
                <div className="col-xs-12 col-sm-4" key={`index${index + 1}`}>
                  <PlayerCard {...dt} />
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ShotTypeModal);
